import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ClientStateService {

  private changeSource = new Subject<boolean>();

  clientStateChanged$ = this.changeSource.asObservable();

  constructor() {
  }

  clientStateChanged(clientStateChanged: boolean) {
    this.changeSource.next(clientStateChanged);
  }
}
